import { Button, ComposedModal, ModalBody, ModalFooter, ModalHeader } from "@carbon/react";
import FileUploader from "../FileUploader/index.js";
import { useTranslation } from "react-i18next";

const EditAvatarModal = ({ 
    isOpen, 
    onClose, 
    onSave, 
    updateLoading,
    onFileChange 
}) => {
    const { t } = useTranslation();
    return (
        <ComposedModal className="profile-modal" open={isOpen} onClose={onClose} size="md">
            <ModalHeader title={t("profile.editAvatar")} />
            <ModalBody>
                <FileUploader
                    types={['image/png', 'image/jpeg', 'image/jpg']}
                    item={''}
                    key={'profile-icon-edit'}
                    output={onFileChange}
                    inModal={true}
                />
            </ModalBody>
            <ModalFooter>
                <Button kind="danger" size="md" onClick={onClose}>
                    {t("common.cancel")}
                </Button>
                <Button
                    kind="primary"
                    size="md"
                    disabled={updateLoading}
                    onClick={onSave}
                >
                    {updateLoading ? t("common.saving") : t("common.save")}
                </Button>
            </ModalFooter>
        </ComposedModal>
    );
};

export default EditAvatarModal;
